import { render, staticRenderFns } from "./MyConnectionsList.vue?vue&type=template&id=40198940"
import script from "./MyConnectionsList.vue?vue&type=script&lang=js"
export * from "./MyConnectionsList.vue?vue&type=script&lang=js"
import style0 from "./MyConnectionsList.vue?vue&type=style&index=0&id=40198940&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports